// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"838bbff9291c130f","3185":"838bbff9291c130f"}[chunkId] + ".css";
};